import { createTheme, PasswordInput } from "@mantine/core";
import type { CSSVariablesResolver, MantineColorsTuple } from "@mantine/core";

// Original Mantine 9.6.3 colour defaults (reference only; unchanged palettes remain available):
// primaryColor: "blue",
// primaryShade: { light: 6, dark: 8 },
// autoContrast: false,
// colors: {
//   blue: ["#e7f5ff", "#d0ebff", "#a5d8ff", "#74c0fc", "#4dabf7", "#339af0", "#228be6", "#1c7ed6", "#1971c2", "#1864ab"],
//   teal: ["#e6fcf5", "#c3fae8", "#96f2d7", "#63e6be", "#38d9a9", "#20c997", "#12b886", "#0ca678", "#099268", "#087f5b"],
// },
// Mantine has no built-in secondary palette setting.
//
// Original project theme before TripBears brand mapping:
// export const theme = createTheme({
//   primaryColor: "teal",
//   defaultRadius: "md",
//   fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
//   headings: { fontWeight: "600" },
//   components: {
//     PasswordInput: PasswordInput.extend({ defaultProps: { visibilityToggleFocusable: true } }),
//   },
// });

// Active custom theme changes follow the original reference above.
// Source: tripbears/constants/Colors.ts. Mobile shades 50–900 map to Mantine 0–9.
// Shade 5 retains the exact mobile 500 brand colours in both schemes.
export const brandColors = {
  primary: ["#d8dbf9", "#bbc0f5", "#9fa6f1", "#828bed", "#6570e9", "#4956e5", "#404cca", "#3842b0", "#2f3896", "#272e7b"],
  secondary: ["#f4d5ed", "#dab6df", "#ca96d1", "#ba77c4", "#aa58b6", "#a34ab0", "#9544a1", "#7d3987", "#652e6d", "#4d2353"],
} satisfies Record<string, MantineColorsTuple>;

// Dark text accents need a lighter shade than filled controls for readable contrast.
export const brandCssVariables: CSSVariablesResolver = () => ({
  variables: {},
  light: {},
  dark: {
    "--mantine-color-primary-text": "var(--mantine-color-primary-3)",
    "--mantine-color-secondary-text": "var(--mantine-color-secondary-3)",
  },
});

export const theme = createTheme({
  colors: brandColors,
  primaryColor: "primary",
  primaryShade: 5,
  autoContrast: true,
  defaultRadius: "md",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
  headings: {
    fontWeight: "600",
  },
  components: {
    // Mantine labels and exposes the toggle state; include it in keyboard order.
    PasswordInput: PasswordInput.extend({ defaultProps: { visibilityToggleFocusable: true } }),
  },
});
